var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfChina({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 118,
    viewBox: "0 0 177 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 118,
    rx: 4,
    fill: "#DE2910"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7607 20.83L55.8163 22.2372L58.2616 20L57.8008 23.2016L60.79 24.7273L57.4521 25.2964L56.8542 28.4743L55.2517 25.6285L51.8888 26.0672L54.2387 23.7391L52.7607 20.83ZM72.1282 32.4545L70.6502 35.3597L73 37.6917L69.6413 37.249L68.0388 40.0988L67.4409 36.917L64.0989 36.3478L67.0922 34.8221L66.6272 31.6245L69.0767 33.8617L72.1282 32.4545ZM68.155 47.3913L69.2677 50.4427L72.6596 50.5099L69.9568 52.4585L70.9408 55.5534L68.155 53.7075L65.3693 55.5534L66.3491 52.4585L63.6463 50.5099L67.0382 50.4427L68.155 47.3913ZM52.7607 60.3557L55.8163 61.7628L58.2616 59.5257L57.8008 62.7273L60.79 64.253L57.4521 64.8221L56.8542 68L55.2517 65.1542L51.8888 65.5929L54.2387 63.2648L52.7607 60.3557ZM35.5895 28.6324L39.4463 39.1897L51.1789 39.419L41.8252 46.17L45.2254 56.8656L35.5895 50.4822L25.9535 56.8656L29.3537 46.17L20 39.419L31.7326 39.1897L35.5895 28.6324Z",
    fill: "#FFDE02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfChina);
export default __webpack_public_path__ + "static/media/Flag_of_China.7e1ca0299726ca099352fbca2859a147.svg";
export { ForwardRef as ReactComponent };